import { render, staticRenderFns } from "./AdminWriteups.vue?vue&type=template&id=565fbca4&"
import script from "./AdminWriteups.vue?vue&type=script&lang=js&"
export * from "./AdminWriteups.vue?vue&type=script&lang=js&"
import style0 from "./AdminWriteups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports